export default {
  isBlocked: false,
  isCovered: false,
  coverClass: "",
  timeout: null,
  scrollbarWidth: 0,

  init() {
    const scrollDiv = document.createElement("div");
    scrollDiv.style = `
      width: 100px;
      height: 100px;
      overflow: scroll;
      position: absolute;
      top: -9999px;
    `;
    document.body.appendChild(scrollDiv);
    this.scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
  },

  blockScroll(blocked) {
    this.isBlocked = blocked;
  },

  showCover(show) {
    this.isCovered = Boolean(show);

    if (show && typeof show === "string") {
      this.coverClass = show;
    } else {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.coverClass = "";
      }, 500);
    }
  },
};
